import { useState } from "react";
import styled from "@emotion/styled";
import { Container, Grid, Box, Button, Typography } from "@mui/material";

// * components
import Authorization from "./Authorization";
import ContractsModal from "./modals/ContractsModal";
import RejectModal from "./modals/RejectModal";
import SharedModal from "./shared/SharedModal";
import SignatureModal from "./modals/SignatureModal";
import RequiestStatusModal from "./modals/RequiestStatusModal";
import StampedSignatures from "./modals/StampedSignatures";
import { useLayoutEffect } from "react";
import axios from "axios";

// * styled
const Main = styled(Box)`
  padding: 10px 0px 30px 0px;
  .userData {
    padding: 20px;
    background: ${(props) =>
      props.theme === "1" ? "#e3e3e34d" : "rgb(245 242 247)"};
  }
`;

export default function Dashboard({
  data,
  userId,
  brandId,
  isMobile,
  isMember,
  isCustomer,
}) {
  // * modals
  const [openContractsModal, setOpenContractsModal] = useState(false);
  const [openRejectModal, setOpenRejectModal] = useState(false);
  const [openSignaturetModal, setOpenSignaturetModal] = useState(false);

  // * request modal
  const [showStatusModal, setShowStatusModal] = useState(false);
  const [requestStatus, setRequestStatus] = useState(false);

  // * stamped signatures
  const [stampedMemberSignature, setStampedMemberSignature] = useState(null);
  const [stampedCustomerSignature, setStampedCustomerSignature] =
    useState(null);
  const [memberSignature, setMemberSignature] = useState(null);
  const [customerSignature, setCustomerSignature] = useState(null);

  const [ip, setIp] = useState("");

  const currentBrand = localStorage.getItem("current_brand");

  // getIP
  const getIp = async () => {
    const res = await axios.get("https://geolocation-db.com/json/");
    setIp(res.data.IPv4);
  };

  useLayoutEffect(() => {
    getIp();
  }, []);

  return (
    <Main theme={currentBrand}>
      {showStatusModal && (
        <SharedModal
          isOpen={showStatusModal}
          setIsOpen={setShowStatusModal}
          modalBody={
            <RequiestStatusModal
              handleClose={setShowStatusModal}
              requestStatus={requestStatus}
            />
          }
        />
      )}
      <SharedModal
        isOpen={openContractsModal}
        setIsOpen={setOpenContractsModal}
        modalHeader={<Typography fontSize={25}>{"Contratos"}</Typography>}
        modalBody={<ContractsModal data={data?.contracts} />}
      />
      <SharedModal
        isOpen={openRejectModal}
        setIsOpen={setOpenRejectModal}
        modalHeader={<Typography fontSize={25}>{"¡Atención!"}</Typography>}
        modalBody={<RejectModal 
          brandId={brandId}
          ip={ip}
        />}
      />

      <SharedModal
        isOpen={openSignaturetModal}
        setIsOpen={setOpenRejectModal}
        modalBody={
          <StampedSignatures
            setStampedCustomerSignature={setStampedCustomerSignature}
            setStampedMemberSignature={setStampedMemberSignature}
            stampedCustomerSignature={stampedCustomerSignature}
            stampedMemberSignature={stampedMemberSignature}
            memberSignature={memberSignature}
            customerSignature={customerSignature}
            ip={ip}
          />
        }
      />

      <SharedModal
        isOpen={openSignaturetModal}
        setIsOpen={setOpenSignaturetModal}
        modalHeader={<Typography fontSize={25}>{"Firmar contrato"}</Typography>}
        modalBody={
          <SignatureModal
            data={data}
            userId={userId}
            brandId={brandId}
            setShowStatusModal={setShowStatusModal}
            setRequestStatus={setRequestStatus}
            setOpenSignaturetModal={setOpenSignaturetModal}
            setStampedCustomerSignature={setStampedCustomerSignature}
            setStampedMemberSignature={setStampedMemberSignature}
            stampedMemberSignature={stampedMemberSignature}
            stampedCustomerSignature={stampedCustomerSignature}
            setMemberSignature={setMemberSignature}
            setCustomerSignature={setCustomerSignature}
            memberSignature={memberSignature}
            customerSignature={customerSignature}
            isMember={isMember}
            isCustomer={isCustomer}
            ip={ip}
          />
        }
      />

      <Grid container spacing={2}>
        <Container>
          <Grid container>
            <Grid item xs={9}>
              <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
                <Typography variant="title" color={"primary"} mt={2}>
                  {"CONTRATO"}
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={3}>
              <Box display={"flex"} alignItems={"center"} flexDirection={"column"}>
                <Typography variant="body2" mt={5}>
                      {'¡Recuerda leer tu contrato!'}
                </Typography>
              </Box>
            </Grid>
          </Grid>
        </Container>

        <Grid item xs={12}>
          <Box className="userData" display={"flex"}  flexDirection={"column"} px={500}>
          <Container>
              <Grid container>
                <Grid item xs={"6"}>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography mr={1}>{"Titular Del Contrato: "}</Typography>
                    <Typography variant="body2">
                      {data?.headers?.customer_name}
                    </Typography>
                  </Box>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography mr={1}>{"Identificación: "}</Typography>
                    <Typography variant="body2">{`
                  ${
                    data?.headers?.customer_document_type
                      ? data?.headers?.customer_document_type
                      : ""
                  } ${
                      data?.headers?.customer_document_number
                        ? data?.headers?.customer_document_number
                        : ""
                    }`}</Typography>
                  </Box>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography mr={1}>{"Fecha de compra: "}</Typography>
                    <Typography variant="body2">
                      {data?.headers?.date_bill}
                    </Typography>
                  </Box>
                </Grid>

                <Grid item xs={"6"}>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography mr={1}>{"Afiliado: "}</Typography>
                    <Typography variant="body2">
                      {data?.headers?.member_name}
                    </Typography>
                  </Box>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography mr={1}>{"Identificación: "}</Typography>
                    <Typography variant="body2">{`
                  ${
                    data?.headers?.member_document_type
                      ? data?.headers?.member_document_type
                      : ""
                  } ${
                      data?.headers?.member_document_number
                        ? data?.headers?.member_document_number
                        : ""
                    }`}</Typography>
                  </Box>
                  <Box display={"flex"} alignItems={"center"}>
                    <Typography mr={1}>{"Producto: "}</Typography>
                    <Typography variant="body2">
                      {data?.headers?.product_name}
                    </Typography>
                  </Box>
                </Grid>
              </Grid>
            </Container>
          </Box>
        </Grid>

        <Grid item xs={12}>
          <Container>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <Typography variant="h6">
                  PARA CONTINUAR DEBE LEER Y ACEPTAR LA AUTORIZACIÓN PARA EL
                  TRATAMIENTO DE DATOS PERSONALES Y DECLARACIÓN DE INGRESOS.
                </Typography>
              </Grid>

              <Grid item xs={12}>
                <Authorization brandId={brandId} />
              </Grid>

              <Grid item xs={12}>
                <Box
                  display={"flex"}
                  justifyContent={"space-between"}
                  mt={isMobile ? 2 : 5}
                  flexDirection={isMobile ? "column" : "row"}
                >
                  <Button
                    disabled={!data.contracts}
                    variant="contained"
                    color="primary"
                    fullWidth={isMobile}
                    onClick={() => setOpenContractsModal(true)}
                  >
                    {"Ver contratos"}
                  </Button>
                  <Box
                    display={"flex"}
                    alignItems={"center"}
                    flexDirection={isMobile ? "column" : "row"}
                  >
                    <Box
                      mr={isMobile ? 0 : 2}
                      my={isMobile ? 1 : 0}
                      width="100%"
                    >
                      <Button
                        variant="contained"
                        color="secondary"
                        fullWidth={isMobile}
                        onClick={() => setOpenRejectModal(true)}
                      >
                        {"Rechazar"}
                      </Button>
                    </Box>
                    <Box width="100%">
                      <Button
                        variant="contained"
                        color="primary"
                        fullWidth={isMobile}
                        onClick={() => setOpenSignaturetModal(true)}
                      >
                        {"Firmar"}
                      </Button>
                    </Box>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Main>
  );
}
